import React from 'react'

const Facebook = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => (
    <svg
        width="26"
        height="25"
        viewBox="0 0 26 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M25.1571 10.4005C24.1919 1.74366 13.3056 -2.94186 5.85213 2.02939C2.81856 4.0507 0.786456 7.40058 0.184089 10.9576C-0.229586 13.4147 0.0389374 16.0361 1.14207 18.3002C2.24523 20.5573 4.08857 22.393 6.48361 23.2643C13.9225 25.9858 24.0321 23.05 25.1571 14.479C25.3385 13.129 25.3095 11.7504 25.1571 10.4005Z"
            fill="#666059"
        />
        <path
            d="M10.736 20.6903C10.736 20.3188 11.0553 13.6621 10.6853 13.6693C10.0829 13.6979 7.95656 13.7121 7.6517 13.6765C7.33967 13.6407 7.19458 11.0053 7.47031 10.9124C7.75332 10.8195 10.736 10.9052 10.736 10.9052C10.736 10.9052 10.3587 7.37698 11.7956 5.91273C13.6607 4.02007 16.9845 4.95574 17.5069 5.36283C17.5941 5.42711 17.5868 7.35556 17.4561 7.56264C17.3908 7.66977 15.9104 6.93411 14.6622 7.41265C13.2833 7.94112 13.3631 9.69099 13.3921 10.8838C14.1976 10.891 16.5127 10.8338 16.6652 11.0123C16.7667 11.1338 16.8756 13.2979 16.4982 13.5835C16.2224 13.7907 13.3486 13.5979 13.3414 13.7265C13.2616 16.1191 13.3849 20.3188 13.3849 20.6973C13.3994 21.0687 10.736 21.0615 10.736 20.6903Z"
            fill="white"
        />
    </svg>
)

export default Facebook
